import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import "./App.css";
import ChatbotUI from "./view/agent/chatbot";

const App = () => {
  // const path = window.location.pathname;

  // const HIDE_CHATBOT_ROUTES = ["/admin", "/user", "/login", "/settings"];

  // const hideChatbot = HIDE_CHATBOT_ROUTES.some(route =>
  //   path.startsWith(route)
  // );


  return (
    <>
      <RouterProvider router={router} />
      {/* {!hideChatbot && <ChatbotUI />} */}
    </>
  );
};

export default App;
